import { and, eq, sql } from "drizzle-orm";
import { priceTypes, productPrices, stockMovements, salesOrders } from "@briolin/db";
import type { TestDb } from "@briolin/db/src/testing.js";
import { resolvePrice } from "./pricing.js";
import { PriceNotFoundError } from "./errors.js";

type Db = TestDb;

export async function resolveDisplayPrice(
  db: Db, args: { counterpartyId?: string | null; productId: string },
): Promise<number> {
  if (args.counterpartyId) {
    return resolvePrice(db, { counterpartyId: args.counterpartyId, productId: args.productId });
  }
  const [retail] = await db.select().from(priceTypes).where(eq(priceTypes.kind, "retail"));
  if (!retail) throw new PriceNotFoundError(args.productId);
  const [row] = await db.select({ price: productPrices.priceKopecks })
    .from(productPrices)
    .where(and(eq(productPrices.productId, args.productId), eq(productPrices.priceTypeId, retail.id)));
  if (!row) throw new PriceNotFoundError(args.productId);
  return row.price;
}

export async function productAvailability(db: Db, productId: string): Promise<number> {
  const [phys] = await db.select({ t: sql<number>`COALESCE(SUM(${stockMovements.qtyDelta}), 0)::int` })
    .from(stockMovements)
    .where(and(eq(stockMovements.productId, productId), eq(stockMovements.kind, "physical")));
  const [res] = await db.select({ t: sql<number>`COALESCE(SUM(${stockMovements.qtyDelta}), 0)::int` })
    .from(stockMovements)
    .innerJoin(salesOrders, sql`${stockMovements.docId} = ${salesOrders.id}`)
    .where(and(
      eq(stockMovements.productId, productId),
      eq(stockMovements.kind, "reserve"),
      eq(stockMovements.docType, "sales_order"),
      eq(salesOrders.status, "open"),
    ));
  return Number(phys?.t ?? 0) - Number(res?.t ?? 0);
}
